import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KazaplanDiaporamaComponent } from './kazaplan-diaporama.component';
import { KazaplanDiaporamaFluxComponent } from './kazaplan-diaporama-flux/kazaplan-diaporama-flux.component';
import { KazaplanDiaporamaPopinComponent } from './kazaplan-diaporama-popin/kazaplan-diaporama-popin.component';
import { Kazaplan360ViewerModule } from '../kazaplan-360-viewer/kazaplan-360-viewer.module';
import { UtilsModule } from '../../../utils/utils.module';
import { FullscreenModule } from '../../../utils/directives/fullscreen/fullscreen.module';
import { KzLoaderModule } from '../../../kz-ui/ui/loader/kz-loader.module';
import { KzIconsModule } from '../../../kz-ui/ui/icon/kz-icons.module';
import { DiapoButtonModule } from '../../../shared/components/diapo-button/diapo-button.module';

@NgModule({
  imports: [
    CommonModule,
    UtilsModule,
    FullscreenModule,
    Kazaplan360ViewerModule,
    KzLoaderModule,
    KzIconsModule,
    DiapoButtonModule,
  ],
  declarations: [
    KazaplanDiaporamaComponent,
    KazaplanDiaporamaFluxComponent,
    KazaplanDiaporamaPopinComponent
  ],
  exports: [
    KazaplanDiaporamaComponent,
    KazaplanDiaporamaFluxComponent,
    KazaplanDiaporamaPopinComponent
  ]
})
export class KazaplanDiaporamaModule { }
